import type { ImagesService } from '@/engine/app/modules/images/Images.service';
import { SlicerMode, type SliceType } from '@/engine/app/modules/images/interfaces';
import React, { useEffect } from 'react';

export const useAIPThickness = (
  imagesService: ImagesService,
  sliceType: SliceType
): {
  thickness: number;
  setThickness: React.Dispatch<React.SetStateAction<number>>;
  updateThickness: (thickness: number) => void;
} => {
  const [thickness, setThickness] = React.useState(0);

  useEffect(() => {
    const subscription = imagesService.subscribeToSliceOrientationChange(sliceType, (orientationInfo) => {
      setThickness(orientationInfo.xRaySlicerParams?.xRaySliceThickness ?? 0.0);
    });

    return (): void => {
      subscription.dispose();
    };
  }, [imagesService, sliceType]);

  const updateThickness = (thickness: number): void => {
    imagesService.setSlicerMode(sliceType, SlicerMode.AIP, thickness)
  };

  return { thickness, setThickness, updateThickness };
};
